import { EventEmitter, Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
// import { Localization } from '../../enums/localization';
import { Observable } from 'rxjs';
export enum Localization {
    English = "en",
    Arabic = "ar"
}

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  private systemAvilabelLang: string[] = [];
 
  /**
   * Creates an instance of LocalizationService.
   * @param {TranslateService} translate
   * @memberof LocalizationService
   */
  constructor(private translate: TranslateService) {
    this.init();
    this.systemAvilabelLang = this.translate.getLangs();
  }
 
  defaultLanguage(): string {
    return this.translate.defaultLang;
  }
 
  selectedLang(): string {
    return this.translate.currentLang;
  }
 
  onLangChange(): EventEmitter<LangChangeEvent> {
    return this.translate.onLangChange;
  }
 
  listOfLangs(): string[] {
    return this.translate.getLangs();
  }
 
  isRtl(): boolean {
    return this.selectedLang() === Localization.Arabic;
  }
 
  addLang(lang: string[]): void {
    this.translate.addLangs(lang);
  }
 
   init(): void {
    let localStorageLang = localStorage.getItem('userLang') ?? 'en';
    this.setLang(localStorageLang);
  }
 
  setLang(lang: string): void {
    const elEn = document.querySelector('#bootstrap-en');
    const elAr = document.querySelector('#bootstrap-ar');
    this.translate.use(lang).subscribe(() => {
      localStorage.setItem('userLang', lang);
      if (lang === 'ar') {
        // add bootstrap ar
        this.generateLinkElement({
          id: 'bootstrap-ar',
          href: '/assets/vendor/bootstrap/bootstrap.rtl.min.css',
          dir: 'rtl',
          lang: 'ar',
        });

        elEn && elEn.remove();
  
  
      } else {
        // en
        this.generateLinkElement({
          id: 'bootstrap-en',
          href: '/assets/vendor/bootstrap/bootstrap.min.css',
          dir: 'ltr',
          lang: 'en',
        });
        elAr && elAr.remove();
      }
    });
  }
  generateLinkElement(props:any) {
    const el = document.createElement('link');
    const htmlEl = document.getElementsByTagName('html')[0];
    el.rel = 'stylesheet';
    el.href = props.href;
    el.id = props.id;
    document.head.prepend(el);
    htmlEl.setAttribute('dir', props.dir);
    htmlEl.setAttribute('lang', props.lang);
    // this.loaderService.isLoading.next(false);
  }
 
  addDefaultLang(lang: string): void {
    this.translate.setDefaultLang(lang);
  }
 
  listOfTranslations(lang: string): Observable<any> {
    return this.translate.getTranslation(lang);
  }
 
  addTranslation(lang: string, translations: Object, shouldMerge: boolean = false): void {
    this.translate.setTranslation(lang, translations, shouldMerge);
  }
 
  getTranslate(key: string | Array<string>, interpolateParams?: Object): Observable<string | Object> {
    return this.translate.get(key, interpolateParams);
  }
 
  instant(key: string, interpolateParams?: Object): string {
    return this.translate.instant(key, interpolateParams);
  }
  
}







